import React from "react";
import bgImg from "../../../Assets/Home/Bg-img.png";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{ backgroundImage: `url(${bgImg})` }}
      className="
        min-h-screen w-full bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center gap-6 sm:gap-8  px-4 sm:px-8 md:px-12 lg:px-16 py-16 sm:py-20 md:py-24 "
    >
      <h1
        className="
        font-krona font-bold text-white text-center   text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight sm:leading-snug md:leading-[1.3] lg:leading-[90px]  tracking-wide max-w-[320px] sm:max-w-[600px] md:max-w-[850px] lg:max-w-[1150px]
      "
      >
        End-to-End Mining, Fabrication & Construction Services
      </h1>

      <p
        className="
        font-krona font-medium text-white text-center  text-sm sm:text-base md:text-lg  max-w-[300px] sm:max-w-[520px] md:max-w-[700px] lg:max-w-[860px]  leading-relaxed  px-2 sm:px-0
      "
      >
        25 years history and experience gives the company a competitive boundary
        for efficient operations.
      </p>

      <button
        id="about"
        onClick={() => {
          navigate("/contact");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className="
        border-2 border-white text-white font-krona px-5 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base lg:text-lg rounded-lg
        hover:bg-white hover:text-black active:scale-95 transition-all duration-200 mt-2 sm:mt-0
      "
      >
        Contact Us
      </button>
    </div>
  );
};

export default Hero;
